import { Row, Col } from 'reactstrap';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import validator from 'validator';
import entityComposition from '../common/classes/entityComposition';
import SingleOtherPicker from '../common/controls/singleOtherPicker';
import SinglePicker from '../common/controls/singlePicker';
class AssetDetailsItemDetailDescription extends Component {
  constructor(props) {
    super(props);
    this.handleDetailChange = this.handleDetailChange.bind(this);
    this.handleCoatingDescriptionChange = this.handleCoatingDescriptionChange.bind(this);
  }
  componentDidMount() {
    const {
      assetCoatingDetail,
      assetCoatingDetailActions,
      assetCoatingDetailDescription,
      assetCoatingDetailDescriptionActions
    } = this.props;
    assetCoatingDetailActions.serverIndex(assetCoatingDetail.indexQuery);
    assetCoatingDetailDescriptionActions.serverIndex(assetCoatingDetailDescription.indexQuery);
  }
  handleDetailChange(value) {
    const {
      onChange
    } = this.props;
    onChange('assetCoatingDetailID', value);
    onChange('assetCoatingDetailDescriptionID', null);
    onChange('assetCoatingDetailDescriptionOther', null);
  }
  handleCoatingDescriptionChange(value) {
    const {
      onChange
    } = this.props;
    let validValue = ''; // validator requires a string and throws error on null
    if (value !== null) {
      validValue = value;
    }
    if (validator.isUUID(validValue)) {
      onChange('assetCoatingDetailDescriptionID', validValue);
      onChange('assetCoatingDetailDescriptionOther', null);
    } else {
      onChange('assetCoatingDetailDescriptionID', null);
      onChange('assetCoatingDetailDescriptionOther', validValue);
    }
  }
  render() {
    const {
      assetCoatingDetail: {
        list: assetCoatingDetailOptions
      },
      assetCoatingDetailDescription: {
        list: assetCoatingDetailDescriptionOptions
      },
      detail: {
        assetCoatingDetailDescriptionID,
        assetCoatingDetailDescriptionOther,
        assetCoatingDetailID
      }
    } = this.props;
    const selectedDetail = assetCoatingDetailID ? assetCoatingDetailOptions.filter(next => next.id === assetCoatingDetailID) : null;
    const filteredCoatingSystems = selectedDetail && selectedDetail.length ? assetCoatingDetailDescriptionOptions.filter(n => n.detailIdentifier === selectedDetail[0].identifier) : [];
    return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 4
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "Detail",
      labelKey: "name",
      onChange: this.handleDetailChange,
      options: assetCoatingDetailOptions,
      placeholder: "Select...",
      value: assetCoatingDetailID,
      returnValueKey: "id",
      searchable: false
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 4
    }, /*#__PURE__*/React.createElement(SingleOtherPicker, {
      label: "Coating System",
      labelKey: "name",
      onChange: this.handleCoatingDescriptionChange,
      options: filteredCoatingSystems,
      placeholder: "Select or add a coating system",
      returnValueKey: "id",
      value: assetCoatingDetailDescriptionID || assetCoatingDetailDescriptionOther
    })));
  }
}
AssetDetailsItemDetailDescription.propTypes = {
  onChange: PropTypes.func.isRequired,
  detail: PropTypes.shape({
    assetCoatingDetailID: PropTypes.string,
    assetCoatingDetailDescriptionID: PropTypes.string,
    assetCoatingDetailDescriptionOther: PropTypes.string
  }).isRequired,
  assetCoatingDetail: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetCoatingDetailActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  assetCoatingDetailDescription: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetCoatingDetailDescriptionActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired
};
export { AssetDetailsItemDetailDescription as TestAssetDetailsItemDetailDescription };
export default entityComposition(AssetDetailsItemDetailDescription, ['assetCoatingDetail', 'assetCoatingDetailDescription']);